function changePrimaryTheme(bgColor, textColor) {
  return {
    '--sops-app-nav-bg-color': `${bgColor}`,
    '--sops-app-nav-text-color': `${textColor}`,

    '--sops-action-primary': `${bgColor}`,
    '--sops-text-on-primary': `${textColor}`,
    '--sops-icon-on-primary': `${textColor}`,
    '--sops-action-primary-hovered': `linear-gradient(180deg, rgba(223, 227, 239, 0.2) 0% ,rgba(255, 255, 255, 0.2) 50.52%, rgba(223, 227, 239, 0.2) 100%), linear-gradient(0deg, ${bgColor}, ${bgColor})`,
    '--sops-action-primary-disabled': `linear-gradient(to bottom, ${bgColor}, ${bgColor})`,
    '--sops-action-primary-pressed': `${bgColor}`,
    '--sops-action-primary-depressed': `${bgColor}`,

    '--p-action-primary': `${bgColor}`,
    '--p-text-on-primary': `${textColor}`,
    '--p-icon-on-primary': `${textColor}`,
    '--p-action-primary-hovered': `linear-gradient(180deg, rgba(223, 227, 239, 0.2) 0% ,rgba(255, 255, 255, 0.2) 50.52%, rgba(223, 227, 239, 0.2) 100%), linear-gradient(0deg, ${bgColor}, ${bgColor})`,
    '--p-action-primary-disabled': `linear-gradient(to bottom, ${bgColor}, ${bgColor})`,
    '--p-action-primary-pressed': `${bgColor}`,
    '--p-action-primary-depressed': `${bgColor}`
  };
}

function setStyle(propertyObject) {
  var elem = document.getElementById('root').firstChild.style;

  for (var property in propertyObject) {
    elem.setProperty(property, propertyObject[property]);
  }
}

export { changePrimaryTheme, setStyle };
